/* Cart drawer & page: line-key changes, discount codes, note, cross-sells (DST-071..077, DST-086). */
(function () {
  'use strict';
  if (window.__dstCart) return; window.__dstCart = true;
  var DST = window.DST;
  var timers = Object.create(null), pending = 0;
  function syncCheckout() {
    var waiting = !!DST.cart.viewStale || pending > 0 || Object.keys(timers).length > 0;
    document.querySelectorAll('[data-cart-root]').forEach(function (root) {
      var invalid = Array.prototype.some.call(root.querySelectorAll('[data-line-qty]'), function (input) { return !!validQty(input); });
      setPending(root, waiting || invalid);
      var express = root.querySelector('.cart__express'); if (express) express.hidden = waiting || invalid;
    });
  }
  document.addEventListener('cart:rendered', syncCheckout);
  document.addEventListener('cart:sync-state', syncCheckout);
  document.addEventListener('submit', function (e) { if (e.target.matches('[data-checkout-form]')) {
    var root = e.target.closest('[data-cart-root]'), invalid = false; root.querySelectorAll('[data-line-qty]').forEach(function (input) { var msg = validQty(input); lineError(input.closest('[data-line-key]'), msg); if (msg) invalid = true; });
    if (invalid || DST.cart.viewStale || pending > 0 || Object.keys(timers).length) { e.preventDefault(); DST.announce(invalid ? 'Correct the quantity before checking out.' : 'Please wait for your bag update before checking out.', true); }
  } }, true);
  document.addEventListener('input', function (e) { if (e.target.matches('[data-line-qty]')) { var line = e.target.closest('[data-line-key]'), key = line.getAttribute('data-line-key'); clearTimeout(timers[key]); delete timers[key]; lineError(line, validQty(e.target)); syncCheckout(); } });
  function lineError(line, msg) { var e = line && line.querySelector('[data-line-error]'); if (e) { e.textContent = msg || ''; e.hidden = !msg; } }
  function setPending(root, on) {
    on = on || !!DST.cart.viewStale;
    root.classList.toggle('is-pending', on);
    root.querySelectorAll('[data-checkout-button]').forEach(function (b) { b.disabled = on; if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
  }
  function change(line, qty) {
    var root = line.closest('[data-cart-root]'), key = line.getAttribute('data-line-key');
    var title = (line.querySelector('.cart-line__title') || {}).textContent || 'Item';
    pending++; syncCheckout(); line.classList.add('is-updating'); lineError(line, '');
    DST.cart.change(key, qty).then(function (cart) {
      DST.announce(qty === 0 ? title + ' removed from your bag.' : title + ' quantity updated. Subtotal ' + DST.formatMoney(cart.total_price) + '.');
      afterRender();
    }).catch(function (err) {
      var fresh = document.querySelector('[data-line-key="' + key + '"]') || line;
      lineError(fresh, err.message); DST.announce(err.message, true);
      fresh.classList.remove('is-updating');
      return DST.cart.refresh();
    }).then(function () { pending = Math.max(0, pending - 1); syncCheckout(); });
  }
  function validQty(input) {
    var v = Number(input.value), step = Number(input.getAttribute('data-step')) || 1, min = Number(input.getAttribute('data-min')) || 1;
    var max = input.max ? Number(input.max) : null;
    if (!/^\d+$/.test(String(input.value).trim())) return 'Enter a whole number.';
    if (v === 0) return '';
    if (v < min) return 'The minimum is ' + min + '.';
    if (v % step !== 0) return 'Sold in multiples of ' + step + '.';
    if (max !== null && v > max) return 'The maximum is ' + max + '.';
    return '';
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-line-step]');
    if (step) {
      var line = step.closest('[data-line-key]'), input = line.querySelector('[data-line-qty]');
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-line-step')));
      input.value = v; schedule(line, input); return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm && rm.closest('[data-cart-root]')) { e.preventDefault(); change(rm.closest('[data-line-key]'), 0); return; }
    var ap = e.target.closest('[data-discount-apply]');
    if (ap) { applyDiscount(ap.closest('[data-discount]')); return; }
    var dr = e.target.closest('[data-discount-remove]');
    if (dr) { removeDiscount(dr.getAttribute('data-discount-remove')); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line-qty]')) schedule(e.target.closest('[data-line-key]'), e.target);
    if (e.target.matches('[data-cart-note]')) DST.cart.update({ note: e.target.value }).catch(function () { DST.announce('We couldn’t save your order note. Please check your bag before checkout.', true); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) { e.preventDefault(); applyDiscount(e.target.closest('[data-discount]')); }
  });
  function schedule(line, input) {
    var key = line.getAttribute('data-line-key');
    var msg = validQty(input);
    lineError(line, msg);
    clearTimeout(timers[key]); delete timers[key];
    if (msg) { syncCheckout(); return; }
    var quantity = Number(input.value);
    timers[key] = setTimeout(function () { delete timers[key]; change(line, quantity); }, 400);
    syncCheckout();
  }
  function currentCodes() {
    return Array.prototype.map.call(document.querySelectorAll('[data-discount-remove]'), function (b) { return b.getAttribute('data-discount-remove'); })
      .filter(function (c, i, a) { return a.indexOf(c) === i; });
  }
  function applyDiscount(box) {
    var input = box.querySelector('[data-discount-input]'), err = box.querySelector('[data-discount-error]');
    var code = input.value.trim(); if (!code) { err.textContent = 'Enter a code.'; err.hidden = false; input.focus(); return; }
    err.hidden = true;
    var codes = currentCodes(); if (codes.indexOf(code) < 0) codes.push(code);
    DST.cart.update({ discount: codes.join(',') }).then(function (cart) {
      var applied = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      afterRender();
      var boxes = document.querySelectorAll('[data-discount]');
      if (!applied || !applied.applicable) {
        boxes.forEach(function (b) { var e2 = b.querySelector('[data-discount-error]'); e2.textContent = '“' + code + '” isn’t valid for this bag.'; e2.hidden = false; });
        DST.announce('Discount code ' + code + ' was not applied.', true);
      } else DST.announce('Discount code ' + code + ' applied. Subtotal ' + DST.formatMoney(cart.total_price) + '.');
    }).catch(function (e2) { err.textContent = e2.message; err.hidden = false; DST.announce(e2.message, true); });
  }
  function removeDiscount(code) {
    var codes = currentCodes().filter(function (c) { return c !== code; });
    DST.cart.update({ discount: codes.join(',') }).then(function () { DST.announce('Discount ' + code + ' removed.'); afterRender(); }).catch(function (e) { DST.announce(e.message, true); });
  }
  function loadXsell() {
    document.querySelectorAll('[data-cart-xsell]').forEach(function (box) {
      if (box.__loaded === box.getAttribute('data-url')) return;
      box.__loaded = box.getAttribute('data-url');
      fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-xsell-inner]');
        box.innerHTML = d ? d.innerHTML : '';
      }).catch(function () { box.innerHTML = ''; });
    });
  }
  function afterRender() { loadXsell(); }
  document.addEventListener('cart:rendered', loadXsell);
  var drawer = document.getElementById('CartDrawer');
  if (drawer) drawer.addEventListener('dialog:open', loadXsell);
  if (document.readyState !== 'loading') loadXsell(); else document.addEventListener('DOMContentLoaded', function () { if (document.querySelector('.template-cart')) loadXsell(); });
})();
